/**
 * 全局配置文件
 */
export default {
    title: '',
    logo: 'numseek',
    key: 'numseek_web', //配置主键,目前用于存储
    indexTitle: 'Sc',
    clientId: 'numseek_web', // 客户端id
    clientSecret: 'numseek_secret', // 客户端密钥
    tenantMode: true, // 是否开启租户模式
    tenantId: '000000', // 管理组租户编号
    captchaMode: true, // 是否开启验证码模式
    switchMode: false, // 是否开启部门切换模式
    tokenTime: 3000,
    tokenHeader: 'Sc-Auth',
    // 单点登录系统认证(sc-auth服务的地)
    ssoUrl: 'http://localhost:8100/oauth/authorize?client_id=numseek_web&response_type=code&redirect_uri=',
    // 单点登录回调地址(Saber服务的登录界面地址)
    redirectUri: 'http://localhost:18887',
    //oauth2配置
    oauth2: {
        // 是否开启注册功能
        registerMode: true,
        // 使用后端工程 @org.springblade.test.Sm2KeyGenerator 获取
        publicKey: '请配置国密sm2公钥',
        // 第三方系统授权地址
        authUrl: 'http://localhost/blade-auth/oauth/render',
        // 单点登录系统认证(cloud端口为8100,boot端口为80)
        ssoUrl:
        'http://localhost:8100/oauth/authorize?client_id=saber3&response_type=code&redirect_uri=',
        // 单点登录回调地址(Saber服务的登录界面地址)
        redirectUri: 'http://localhost:2888/login',
    },
  };
  